import _regenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import api from '@/api';
import MemberFreezeRecords from '../../memberFreezeRecords/edit/index';
export default {
  components: {
    MemberFreezeRecords: MemberFreezeRecords
  },
  name: 'SelectMemberMangerList',
  data: function data() {
    return {
      isSelect: this.checkauthority('member_select'),
      isCreate: this.checkauthority('member_add'),
      selectForm: {
        noOrPhone: null
      },
      freezeRecordsDisabled: false,
      freezeRecordsDialogVisible: false,
      pageNo: 1,
      pageSize: 10,
      tableSelects: [],
      tableData: [],
      pageTotal: 0
    };
  },
  methods: {
    freezeRecordOpen: function freezeRecordOpen(item) {
      this.$refs.memberFreezeRecords.setTitle('冻结');
      this.$refs.memberFreezeRecords.setData(item);
      this.freezeRecordsDialogVisible = true;
    },
    freezeRecordsClose: function freezeRecordsClose() {
      this.freezeRecordsDialogVisible = false;
    },
    changeMemberType: function changeMemberType(type) {
      return this.enums.checkEnumsValue(this.memberTypes, type, '-');
    },
    initEunmData: function initEunmData() {
      this.getMemberTypeList('member_type');
    },
    getMemberTypeList: function getMemberTypeList(name) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var par, res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              par = {
                name: name
              };
              _context.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context.v;
              _this.memberTypes = res.body;
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    dalete: function dalete(index, data) {
      var _this2 = this;
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this2.daleteApi(index, data);
      }).catch(function () {
        _this2.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    daleteApi: function daleteApi(index, data) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var par;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              par = {
                memberId: data.memberId
              };
              _context2.n = 1;
              return api.DELETE_MEMBER(par);
            case 1:
              _this3.initTableData();
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    deleteBatchApi: function deleteBatchApi(par) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return api.DELETE_BATCH_MEMBER(par);
            case 1:
              _this4.$message.success('操作成功');
              _this4.initTableData();
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    reset: function reset() {
      this.pageNo = 1;
      this.selectForm.noOrPhone = '';
      this.tableData = [];
    },
    search: function search() {
      this.pageNo = 1;
      this.initTableData();
    },
    initTableData: function initTableData() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var par, res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              if (!(_this5.selectForm.noOrPhone === '' || _this5.selectForm.noOrPhone === null)) {
                _context4.n = 1;
                break;
              }
              _this5.$message.error('请输入ID号或手机号');
              return _context4.a(2);
            case 1:
              par = {
                pageNo: _this5.pageNo,
                pageSize: _this5.pageSize,
                sortType: 0,
                noOrPhone: _this5.selectForm.noOrPhone
              };
              _context4.n = 2;
              return api.GET_SELECT_MANGER_MEMBER_TOURISTS_PAGE_LIST(par);
            case 2:
              res = _context4.v;
              _this5.tableData = res.body.datas;
              _this5.pageTotal = res.body.sumDataCount;
            case 3:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.initTableData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNo = val;
      this.initTableData();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.tableSelects = val;
    }
  },
  created: function created() {
    if (this.isSelect) {
      return;
    }
    this.initEunmData();
  }
};